import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["ratingStars", "label"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LabeledRatingStarsMixin } from '../../mixins/components/LabeledRatingStarsMixin';
export var StyledLabeledRatingStars = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledLabeledRatingStars",
  componentId: "c11n-8-64-0__sc-rmwy4l-0"
})(["", ""], LabeledRatingStarsMixin);
/**
 * Displays a [`RatingStars`](#/More%20components?id=ratingstars) component with
 * an accompanying text label.
 *
 * @since 8.4.0
 */

var LabeledRatingStars = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var ratingStars = _ref.ratingStars,
      label = _ref.label,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledLabeledRatingStars, _extends({}, rest, {
    ref: ref
  }), ratingStars, label);
});
LabeledRatingStars.displayName = 'LabeledRatingStars';
LabeledRatingStars.propTypes = {
  /** The [`RatingStars`](#/More%20components?id=ratingstars) component. */
  ratingStars: PropTypes.node.isRequired,

  /**
   * The label to display next to the Rating Stars. Usually, this will be
   * a [`TextButton`](#/Button%20components?id=textbutton) component.
   */
  label: PropTypes.node
};
LabeledRatingStars.defaultProps = {
  label: undefined
};
/** @component */

export default LabeledRatingStars;